import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroListaPreCadastroProduto {
  lastSetDefault: Date;
  page: number;
  order: string;

  NCODIGO: number | null;
  CSTATUS: string;
  CSTATUS_IN: Array<string> | string;
  DINCLUSAO_DE: Date;
  DINCLUSAO_ATE: Date;
  CURGENTE: string;
  CUSUARIO: string;
  CTIPO_IN: Array<string> | string;

}

export class FiltroListaPreCadastroProduto {

  dados: IFiltroListaPreCadastroProduto;
  storageName: string;

  CSTATUSlista = [
    { value: '2', label: 'Solicitante'},
    { value: '1', label: 'Engenharia'},
    { value: '4', label: 'Gerência Negado'},
    { value: '3', label: 'Compras'},
    { value: '6', label: 'Compras Negado'},
    { value: '5', label: 'Controladoria'},
    { value: '8', label: 'Controladoria Negado'},
    { value: '9', label: 'Finalizado'},
    { value: 'A', label: 'Cancelado'},
  ];

  CURGENTElista = [
    { value: ' ', label: 'Todos'},
    { value: 'S', label: 'Sim'},
    { value: 'N', label: 'Não'},
  ];

  constructor(private poStorageService: PoStorageService, storageName: string = 'filtro-lista-pre-produto') {
    this.dados = this.setDefault();
    this.storageName = storageName;

    this.poStorageService.get(this.storageName).then((filtro: IFiltroListaPreCadastroProduto) => {
        if (filtro) {
          const {
            lastSetDefault,
            DINCLUSAO_DE,
            DINCLUSAO_ATE,
            CSTATUS_IN,
            CTIPO_IN,
          } = filtro;

          if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
            this.dados = this.setDefault();
          } else {
            this.dados = {
              ...filtro,
              lastSetDefault: new Date(lastSetDefault),
              DINCLUSAO_DE: new Date(DINCLUSAO_DE),
              DINCLUSAO_ATE: new Date(DINCLUSAO_ATE),
              CSTATUS_IN: CSTATUS_IN?.length ? CSTATUS_IN : CSTATUS_IN.toString(),
              CTIPO_IN: CTIPO_IN?.length ? CTIPO_IN : CTIPO_IN.toString(),
            };
          }
        }
      });
  }

  public setDefault = (): IFiltroListaPreCadastroProduto => {
    return {
      lastSetDefault: new Date(),
      page: 1,
      order: '',

      NCODIGO: null,
      CSTATUS: '',
      CSTATUS_IN: '',
      CTIPO_IN: '',
      DINCLUSAO_DE: this.getData(-365),
      DINCLUSAO_ATE: new Date,
      CURGENTE: '',
      CUSUARIO: '',

    };
  };

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  };

  private getData = (dias: number): Date => {
    const data = new Date();
    data.setDate(data.getDate() + dias);
    return data;
  }

}
